// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__37gCn","overlay":"spinner_overlay__2NSRf","appear":"spinner_appear__30OzL"};